<template>
  <v-card style="min-width:650px;" elevation="0">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon color="white">playlist_play</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="modal-title">
            <span class="text-white text-truncate-popover">Delete "{{playlist.name}}"</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card elevation="0">
      <v-card-title>
        Are you sure that you would like to delete "{{playlist.name}}"?
      </v-card-title>
      <v-card-text v-if="hasPlaylistSections">
        This will remove this playlist from all assigned sections:
        <ul :style="{ paddingLeft: '24px' }">
          <li v-for="section in playlist.sections" :key="section.id">{{section.name}}</li>
        </ul>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-card-actions class="row-space" style="height:56px">
      <v-btn flat class="branded-grey" @click="setDashModal(null)">Cancel</v-btn>
      <div class="row-center">
        <v-btn class="branded-background text-white" @click="confirmDeletePlaylist()" :loading="playlistModalLoading">Delete</v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
/* global _ */
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';

export default {
  name: 'ConfirmPlaylistDelete',
  props: [
    'playlist', 
  ],
  computed: {
    ...mapState('instructors', [
      'playlistModalLoading',
    ]),
    ...mapGetters('instructors', [
      'classes',
      'instructorAjaxing',
      'queryParamsInstructors',
    ]),
    hasPlaylistSections() {
      return _.get(this.playlist, 'sections', 0).length > 0;
    },
  },
  methods: {
    ...mapMutations([
      'setDashModal',
    ]),
    ...mapActions('instructors', [
      'deletePlaylist',
    ]),
    confirmDeletePlaylist() {
      this.deletePlaylist(this.playlist.id);
    }
  },
};
</script>


